import * as React from "react";
import {Link} from "react-router-dom";
import {OrdersState} from "../../reducers/orders";
import {OrderSearchParams} from "../../models/order";
import {getOrderList, OrdersAction, updateSearchParams} from "../../actions/orders";
import {ApplicationState} from "../../reducers";
import {connect} from "react-redux";
import {FormGroup, FormControl, ControlLabel, Col, Row, Button, Table} from "react-bootstrap";
import {DateRangePicker} from "react-dates";
import * as moment from "moment";
import {clone} from "lodash";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import {LOCAL_DATE_FMT, moneyFormat} from "../../utils";

interface OrderGridProps extends OrdersState {
    getOrderList: (params: OrderSearchParams) => Promise<OrdersAction>;
    updateSearchParams: (params: OrderSearchParams) => OrdersAction;
}

interface State {
    focusedInput: any;
}

class OrderGrid extends React.Component<OrderGridProps, State> {
    constructor(props: OrderGridProps) {
        super(props);
        this.state = {focusedInput: null};
    }
    componentDidMount(): void {
        this.doSearch();
    }

    doSearch() {
        this.props.getOrderList(this.props.orderSearchParams);
    }

    public render(): JSX.Element {
        const {orderSearchParams} = this.props;
        return (
            <div>
                <Row className={"top-search"}>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>Search</ControlLabel>
                            <FormControl type="text"
                                         value={orderSearchParams.search}
                                         onChange={(e: any) =>
                                             this.updateSearch((s: OrderSearchParams) => s.search = e.target.value)} />
                        </FormGroup>
                    </Col>
                    <Col xs={4}>
                        <FormGroup>
                            <ControlLabel>Check-in -> Check-out</ControlLabel>
                            <div>
                                <DateRangePicker
                                    showClearDates
                                    startDateId="checkin"
                                    endDateId="checkout"
                                    enableOutsideDays={false}
                                    isOutsideRange={() => false}
                                    startDate={orderSearchParams.minDate ? moment(orderSearchParams.minDate) : null}
                                    endDate={orderSearchParams.maxDate ? moment(orderSearchParams.maxDate) : null}
                                    onDatesChange={evt => {
                                        this.updateSearch((s: OrderSearchParams) => {
                                            if (evt.startDate) {
                                                s.minDate = evt.startDate.format(LOCAL_DATE_FMT);
                                            } else {
                                                s.minDate = null;
                                            }
                                            if (evt.endDate) {
                                                s.maxDate = evt.endDate.format(LOCAL_DATE_FMT);
                                            } else {
                                                s.maxDate = null;
                                            }
                                        });
                                    }}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={(focusedInput: any) => this.setState({ focusedInput })}
                                />
                            </div>
                        </FormGroup>
                    </Col>
                    <Col xs={2}>
                        <ControlLabel>&nbsp;</ControlLabel>
                        <Button bsStyle={"primary"} onClick={() => this.doSearch()}>Find Orders</Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Table bordered striped hover>
                            <thead>
                                <tr>
                                    <th>Order Number</th>
                                    <th>Order Date</th>
                                    <th>Order Status</th>
                                    <th>Customer Email</th>
                                    <th>Customer Phone</th>
                                    <th>Order Total</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.props.orderList.map(order => {
                                return (
                                    <tr key={order.id}>
                                        <td><Link to={`/admin/orders/${order.id}`}>{order.orderNumber}</Link></td>
                                        <td>{moment(order.createdOn).format("LLLL")}</td>
                                        <td>{order.orderStatus}</td>
                                        <td>{order.user && order.user.email}</td>
                                        <td>{order.user && order.user.phoneNumber}</td>
                                        <td>{moneyFormat(order.grandTotal)}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        );
    }

    private updateSearch(f: (s: OrderSearchParams) => void) {
        const s = clone(this.props.orderSearchParams);
        f(s);
        this.props.updateSearchParams(s);
    }
}

const connected = connect((state: ApplicationState) => ({
    ...state.orders
}), {
    getOrderList,
    updateSearchParams,
})(OrderGrid);

export default connected;



// WEBPACK FOOTER //
// ./src/components/admin/OrderGrid.tsx